import { useQuery } from '@apollo/client';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { fetchTicketCreatePermission } from '../queries/fetchTicketCreatePermission';
import { isAuthorizationError } from '../../../utils/isAuthorizationError';
export const useHasTicketCreateAccess = () => {
  const {
    data,
    loading,
    error
  } = useQuery(fetchTicketCreatePermission, {});
  if (error && !isAuthorizationError(error)) {
    reportError({
      error
    });
  }
  return {
    hasTicketCreateAccess: data && data.objectTypePermissions ? data.objectTypePermissions.currentUserCanCreate : false,
    loading
  };
};